// components/lesson/renderers/GoogleEmbedRenderer.tsx
"use client";
// LÀM GÌ?          Hiển thị bài giảng PDF/Docs/Slides từ Google Drive qua iframe /preview, có trạng thái đang tải,
//                  fallback "Mở trong tab mới" khi Google không cho nhúng (file chưa share "Anyone with the link").
// VÌ SAO TỒN TẠI?  Lesson content_type 'document' | 'slide' chưa có renderer → khung trống.
// DB SCHEMA:       lessons.content_url
// FILE NÀO DÙNG:   components/lesson/LessonInline.tsx, components/lesson/LessonFullscreen.tsx

import { useEffect, useState } from "react";
import { Loader2, ExternalLink, FileWarning } from "lucide-react";
import { parseGoogleUrl } from "@/lib/google";

export default function GoogleEmbedRenderer({ url, title, className = "h-[500px]" }: {
  url: string | null | undefined; title: string; className?: string;
}) {
  const g = parseGoogleUrl(url);
  const [loaded, setLoaded] = useState(false);
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    setLoaded(false); setSlow(false);
    const t = setTimeout(() => setSlow(true), 8000);
    return () => clearTimeout(t);
  }, [g?.embedUrl]);

  if (!g) {
    return (
      <div className={`${className} flex flex-col items-center justify-center gap-2 bg-slate-50 text-center p-6`}>
        <FileWarning className="w-8 h-8 text-slate-400" />
        <p className="text-[13px] font-semibold text-slate-600">Link tài liệu không hợp lệ</p>
        <p className="text-[11px] text-slate-500">Cần link Google Drive, Docs hoặc Slides.</p>
      </div>
    );
  }

  return (
    <div className={`relative ${className} bg-[#f5f4f0]`}>
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-center p-6">
          <Loader2 className="w-6 h-6 animate-spin text-teal-600" />
          <p className="text-[12px] text-slate-500">Đang tải tài liệu…</p>
          {slow && (
            <p className="text-[11px] text-slate-500 max-w-xs">
              Tải lâu? File có thể chưa được chia sẻ công khai.{" "}
              <a href={g.openUrl} target="_blank" rel="noopener noreferrer" className="text-teal-700 font-semibold underline">Mở trong tab mới</a>
            </p>
          )}
        </div>
      )}
      <iframe
        key={g.embedUrl}
        src={g.embedUrl}
        title={title}
        onLoad={() => setLoaded(true)}
        className={`w-full h-full border-0 transition-opacity ${loaded ? "opacity-100" : "opacity-0"}`}
        allow="autoplay; fullscreen"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation"
      />
    </div>
  );
}